import Group from '@/modules/groups/models/group'

export default class Category {
  constructor (
    id = null,
    name = 'Default Category',
    routineInspectionDurationDays = null,
    deadlineDays = null,
    enabled = 1,
    groups = [],
    object = ''
  ) {
    this.id = id
    this.name = name
    this.routine_inspection_duration_days = routineInspectionDurationDays
    this.deadline_days = deadlineDays
    this.enabled = enabled
    this.groups = groups
    this.groupNames = groups.length ? groups.map(group => group.name).join(', ') : ''
    this.object = object
  }

  static fromJson (json) {
    return new Category(
      json.id,
      json.name,
      json.routine_inspection_duration_days,
      json.deadline_days,
      json.enabled,
      json.groups?.data.length > 0 ? Group.fromJsonArray(json.groups.data) : [],
      json.object
    )
  }

  static fromJsonArray (json) {
    const result = []
    json.forEach(category => {
      result.push(this.fromJson(category))
    })
    return result
  }
}
